import { plural, t } from "@lingui/core/macro";
import React from "react";
import RefinedListDropdown, {
  DynamicTitleFunction
} from "../RefinementListFilter/RefinedListDropdown";
import RefinedList from "../RefinementListFilter/RefinedList";
import { dayGroupItemsTransformer } from "./utils";
import { cruisesLabel } from "src/utils/cruise";

const buildDynamicTitle: DynamicTitleFunction = (count) =>
  count > 0
    ? plural(count, {
        one: "# duration selected",
        other: "# durations selected"
      })
    : t`Set the cruise duration`;

export const DurationFilterDropDown: React.FC = () => {
  return (
    <RefinedListDropdown
      label={t`How many days?`}
      dynamicTitle={buildDynamicTitle}
      dataContentPiece="duration_filter_interaction"
      attribute="dayGroup"
      operator="or"
      transformItems={dayGroupItemsTransformer()}
      limit={100}
      counterLabel={cruisesLabel}
    />
  );
};

export const DurationFilterList: React.FC = () => {
  return (
    <RefinedList
      title={buildDynamicTitle}
      dataContentName="duration_filter_interaction"
      attribute="dayGroup"
      operator="or"
      transformItems={dayGroupItemsTransformer()}
      limit={100}
    />
  );
};
